export const ADMIN_PANEL_LANG_PATH = 'views/Admin/stalled/translation';
export const ADMIN_INSPECTION_LANG_PATH = 'views/Admin/Inspection/translation';
export const BUYERS_LANG_PATH = 'views/Buyers/translation';
export const COMPANY_PROFILE_LANG_PATH = 'views/CompanyProfile/translation';
export const DASHBOARD_LANG_PATH = 'views/Dashboard/translation';
export const INSPECTION_LANG_PATH = 'views/Inspection/translation';
export const FACTORY_AUDIT_LANG_PATH = 'views/FactoryAudit/translation';
export const LOGIN_LANG_PATH = 'views/Login/translation';
export const ALI_LOGIN_LANG_PATH = 'views/Alibaba/Login/translation';
export const MESSAGE_CENTER_LANG_PATH = 'views/MessageCenter/translation';
export const NOTIFICATION_CENTER_LANG_PATH = 'views/NotificationCenter/translation';
export const PRIVACY_SETTING_LANG_PATH = 'views/PrivacySetting/translation';
export const PRODUCT_TESTING_LANG_PATH = 'views/ProductTesting/translation';
export const REGISTRATION_LANG_PATH = 'views/Registration/translation';
export const ALI_REGISTRATION_LANG_PATH = 'views/Alibaba/Registration/translation';
export const REPORT_UPLOAD_LANG_PATH = 'views/ReportUpload/translation';
export const SUPPLIER_MANAGER_LANG_PATH = 'views/SupplierManager/translation';
export const SUPPLIER_INVITATION_LANG_PATH = 'views/SupplierInvitation/translation';
export const TAG_MANAGEMENT_LANG_PATH = 'views/TagManagement/translation';
export const FORM_UPLOAD_BR_PATH = 'views/FormUploadBR/translation';
export const FEDEX_LANG_PATH = 'views/FedEx/translation';
export const PAYER_LIST_LANG_PATH = 'views/PayerList/translation';
export const TEST_PLAN_LANG_PATH = 'views/TestPlan/translation';
export const TEST_PLAN_ALI_LANG_PATH = 'views/Alibaba/TestPlan/translation';
export const TEST_PLAN_ADMIN_LANG_PATH = 'views/Admin/TestPlan/translations';
export const TEST_LINES_LANG_PATH = 'views/Admin/TestLines/translation';
export const PRODUCT_MANAGEMENT_PATH = 'views/ProductDetail/translations';
export const MODULE_INVOICE_LANG_PATH = 'views/ActionInvoice/translation';
export const TAB_INVOICE_LANG_PATH = 'views/Invoice/translation';
export const TAB_ATTACHMENT_LANG_PATH = 'views/Attachment/translation';
export const BRANDED_LOGIN_PATH = 'views/BrandedLogin/translation';
export const DESKTOP_REVIEW_LANG_PATH = 'views/DesktopReview/translation';
